const initialstate = {
    data: [],
    viewdata: [],
    approvedata: [],
    rejectdata: [],
    docdata: [],
}

const AdDonorDocument = (state = initialstate, action: any) => {
    switch (action.type) {
        case 'fetch_data_success':
            return { ...state, data: action.payload };
        case 'FETCH_VIEW_DATA_SUCCESS':
            return { ...state, viewdata: action.payload };
        case 'Approve_DATA_SUCCESS':
            return { ...state, approvedata: action.payload };
        case 'Reject_DATA_SUCCESS':
            return { ...state, rejectdata: action.payload };
        case 'VIEW_DATA_SUCCESS':
            return { ...state, docdata: action.payload };
        case 'EMPTY_DOC_DATA':
            return { ...state, docdata: [] };
        default:
            return state;
    }
};
export default AdDonorDocument;